import {inject} from '@angular/core';
import {CanActivateFn, Router} from '@angular/router';
import {firstValueFrom} from 'rxjs';
import {AuthService} from '../../services/auth/auth';

export const rootAdminGuard: CanActivateFn = async () => {
  const auth: AuthService = inject(AuthService);
  const router: Router = inject(Router);

  await auth.loadToken();

  if (!auth.isLoggedIn()) {
    return router.createUrlTree(['/login']);
  }

  if (!auth.currentUser()) {
    try {
      await firstValueFrom(auth.loadCurrentUser());
    } catch {
      return router.createUrlTree(['/login']);
    }
  }

  return auth.isRootAdmin() ? true : router.createUrlTree(['/home']);
};
